module.exports = __webpack_public_path__ + "img/act.e25f5254.svg";